import { reducer as form } from 'redux-form';

import app from './app';
import barredLocations from './barred-locations';
import groupManagementView from './group-management-view';
import groups from './groups';
import opportunityCandidates from './opportunit-candidates';
import opportunityCollaborators from './opportunity-collaborators';
import opportunityLanguages from './opportunity-languages';
import opportunities from './opportunities';
import languages from './languages';
import notifications from './notifications';
import talent from './talent';
import userManagementView from './user-management-view';
import userOpportunities from './user-opportunities';
import users from './users';

export default {
  app,
  barredLocations,
  form,
  groupManagementView,
  groups,
  languages,
  notifications,
  opportunities,
  opportunityCandidates,
  opportunityCollaborators,
  opportunityLanguages,
  talent,
  userManagementView,
  userOpportunities,
  users,
};
